import { CHANGE_PAGE } from "../utils/actionTypes";

const INITIAL_STATE = {
  page: 1,
  offset: 0
};

const changePage = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHANGE_PAGE:
      return {
        ...state,
        page: action.payload.page,
        offset: action.payload.offset
      };
    default:
      return state;
  }
};

export default changePage;



// WEBPACK FOOTER //
// ./src/reducers/changePage.js